import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";


import CacheBuster from "../../../lib/caching/CacheBuster"
import DeviceInfo from "../../../lib/device/DeviceInfo";
import ConfigService from "../../../../services/ConfigService";
import AuthService from "../../../../services/AuthService";
import CoreService from "../../../../services/CoreService";
import DataService from "../../../../services/DataService";
import LocalStorageService from "../../../../services/LocalStorageService";
import LocalMasterDataService from "../../../../services/LocalMasterDataService";

import LoginPanel from "./Components/LoginPanel";
import gcObservationsLogo from "../../../../assets/images/logos/glasschain-mra-logo.png";
import "./../../CSS/auth-styles.css";



export default class AuthPage
  extends Component {
  constructor(props) {
    super(props);

    this.isSupportedDevice = DeviceInfo.isSupportedBrowser(this.props.deviceInfo);
    this.ConfigService = new ConfigService();
    this.authService = new AuthService();
    this.localStorageService = new LocalStorageService();
    this.localMasterDataService = new LocalMasterDataService();
    this.coreService = new CoreService();

    this.state =
    {
      buildVersion: "",
      appVersion: "",
      isNewBuild: false,
      errorBag: {},
      isBusy: false,
      busyMsg: "",
      lastUserSession: null,
      forceMastersUpdate: false
    }

    this.checkBuild = this.checkBuild.bind(this);
    this.onLoginAttempt = this.onLoginAttempt.bind(this);
    this.toggleForceMastersUpdate = this.toggleForceMastersUpdate.bind(this);
    this.syncMasterDataCatalogs = this.syncMasterDataCatalogs.bind(this);
    this.syncMasterDataCatalog = this.syncMasterDataCatalog.bind(this);
    this.deleteErrorBagKey = this.deleteErrorBagKey.bind(this);
    this.busyOn = this.busyOn.bind(this);
    this.busyOff = this.busyOff.bind(this);
    this.busyMsg = this.busyMsg.bind(this);

  }

  async componentDidMount() {
    this.busyOn("Checking your version and device...");
    this.sleep(2000);
    try{
      await this.checkBuild();
      if (!this.isSupportedDevice)
      {
        var newErrorBag = {};
        newErrorBag.device = "You are trying to use an unsupported Device and/or Browser";
        this.setState({errorBag: newErrorBag});
      }
      else 
      {
        if (this.localStorageService.hasLastUserSession())
        {
          var lastUserSession = this.localStorageService.getLastUserSession();
          this.setState({lastUserSession: lastUserSession});
        }
      }
      var appVersion = this.ConfigService.getAppVersion();
      this.setState({appVersion: appVersion});
    }
    finally{
      this.busyOff();
    }
  }


  busyOn(msg)
  {
    this.setState({isBusy: true, busyMsg: msg});
  }

  busyOff()
  {
    this.setState({isBusy: false, busyMsg: ""});
  }

  busyMsg(msg)
  {
    this.setState({busyMsg: msg});
  }

  async sleep(ms)
  {
    await new Promise(r => setTimeout(r, ms));
  }

  async checkBuild() {
    var cacheBuster = new CacheBuster();
    var hasLatestBuild = await cacheBuster.isLatestBuild();
    if (!hasLatestBuild) {
      this.setState({isNewBuild: true});
      this.busyMsg("Found new version(" + cacheBuster.buildVer + "). Refreshing your system");
      await cacheBuster.refreshCacheAndReload();
    }
    this.setState({ buildVersion: cacheBuster.buildVer });
  }



  toggleForceMastersUpdate()
  {
    var currentForceMastersUpdate = this.state.forceMastersUpdate;
    this.setState({forceMastersUpdate: !currentForceMastersUpdate})
  }

  async syncMasterDataCatalogs(gcid, valueBag, errorBag, sessionToken)
  {
    var masterCatalogs = ["commoditiescatalog", "productscatalog", "poolscatalog", "warehousescatalog"];
    for(var i=0; i<masterCatalogs.length; i++)
    {
      var catalog = masterCatalogs[i];
      var syncResult = await this.syncMasterDataCatalog(catalog, gcid, valueBag, errorBag, sessionToken);
      if (!syncResult) return false;
    }
    return true;
  }

  async syncMasterDataCatalog(catalog, gcid, valueBag, errorBag, sessionToken)
  {
    // For productscatalog, only download if it doesn't exist locally (unless force update is on).
    // Users can use the Force catalog update flag to pull it when needed.
    if (catalog === "productscatalog" && !this.state.forceMastersUpdate)
    {
      this.busyMsg("Checking for local " + catalog + "...");
      var hasLocalCatalog = await this.localMasterDataService.hasMasterCatalog(valueBag.gcid, catalog);
      if (!hasLocalCatalog.hasError && hasLocalCatalog.dataResult)
      {
        this.busyMsg(catalog + " exists locally. Skipping update.");
        return true;
      }
    }

    this.busyMsg("Checking for updated master data " + catalog + "...");
    var lastUpdatedTicksResult = await this.coreService.fetchMasterCatalogLastUpdateTicks(valueBag.gcid, catalog, sessionToken);
    if (lastUpdatedTicksResult.hasError){
      errorBag.auth = "There was a problem getting " + catalog + " last-updated information. "
      errorBag.auth = errorBag.auth + lastUpdatedTicksResult.messages.join(". ");
      this.setState({ errorBag: errorBag });
      return false;
    }

    var serverLastUpdatedTicks = lastUpdatedTicksResult.dataResult;
    var replaceLocalMasterDataResult = await this.localMasterDataService.isLocalMasterCatalogOlder(valueBag.gcid, catalog, serverLastUpdatedTicks);
    if (replaceLocalMasterDataResult.hasError)
    {
      errorBag.auth = "There was a problem comparing " + catalog + " last-updated information between local and cloud services. "
      errorBag.auth = errorBag.auth + replaceLocalMasterDataResult.messages.join(". ");
      this.setState({ errorBag: errorBag });
      return false;
    }

    var mastersNeedUpdate = ((replaceLocalMasterDataResult.dataResult) || (this.state.forceMastersUpdate));
 
    // const mastersNeedUpdate = false;
    if (mastersNeedUpdate)
    {
      this.busyMsg("Fetching remote " + catalog + "...")
      var fetchCatResult = await this.coreService.fetchMasterCatalog(gcid, catalog, sessionToken);
      if (fetchCatResult.hasError)
      {
        errorBag.auth = "There was a problem fetching remote " + catalog + " for update. "
        errorBag.auth = errorBag.auth + fetchCatResult.messages.join(". ");
        this.setState({ errorBag: errorBag });
        return false;
      }
      var catalogData = fetchCatResult.dataResult;


      if (catalog === "warehousescatalog")
      {
        this.busyMsg("Fetching Receiving Warehouse Aux Info catalog...")
        var warehouseAuxInfoCatResult = await this.coreService.fetchMasterCatalog(gcid, "warehouseauxinfocatalog", sessionToken); 
        if (warehouseAuxInfoCatResult.hasError)
        {
          errorBag.auth = "There was a problem fetching remote warehouse catalog auxiliary data. "
          errorBag.auth = errorBag.auth + warehouseAuxInfoCatResult.messages.join(". ");
          this.setState({ errorBag: errorBag });
          return false;
        } 
        this.busyMsg("Updating Receiving Warehouses catalog with auxiliary information...")
        // interleave auxinfo data with warehouse info
        var warehouseCat = catalogData;
        var updatedWarehouses = warehouseCat.warehouses.map(w =>{
          var auxInfo = warehouseAuxInfoCatResult.dataResult.warehouseAuxInfoList.find(aux => aux.warehouse.id === w.warehouse.id);
          if (auxInfo)
          {
            w.auxInfo = auxInfo;
          }
            return w;
        });
        // filter out any warehouses that do NOT have printer information
        var filteredWarehouses = updatedWarehouses.filter(warehouse => ((warehouse.auxInfo) && (warehouse.auxInfo.sublocations)));
        //warehouseCat.warehouses = filteredWarehouses;
        catalogData.warehouses = filteredWarehouses; 
        this.busyMsg("Warehouses have been successfully filtered and updated with auxiliary information (about tags, printers, etc).")
      }


      this.busyMsg("Updating local " + catalog + "...")
      var updateLocalCatResult = await this.localMasterDataService.addMasterCatalog(gcid, catalog, catalogData);
      if (updateLocalCatResult.hasError)
      {
        errorBag.auth = "There was a problem updating the local " + catalog + ". "
        errorBag.auth = errorBag.auth + updateLocalCatResult.messages.join(". ");
        this.setState({ errorBag: errorBag });
        return false;
      }
    }
    this.busyMsg(catalog + " is up-to-date. ")
    return true;
  }


 async onLoginAttempt(valueBag)
 {
   this.busyOn("Validating...");
  try{
    var errorBag = this.getValidationErrors(valueBag);
    if (Object.keys(errorBag).length > 0) {
      this.setState({ errorBag: errorBag });
      return;
    }
    // clear the errorBag messages
    this.setState({errorBag: {}});
    // if we got this far, then let's let the user be able to read the message if it goes really fast
    await this.sleep(1000);

    this.busyMsg("Authorizing...");
    let isAuthorizedResult = await this.authService.isAuthorizedUserLogin(valueBag.gcid, valueBag.uid, valueBag.pwd);
    if (isAuthorizedResult.hasError) {
      errorBag.auth = "There was a problem checking your user authorization. "
      errorBag.auth = errorBag.auth + isAuthorizedResult.messages.join(". ");
      this.setState({ errorBag: errorBag });
      return;
    }
    if (!isAuthorizedResult.dataResult) {
      errorBag.auth = "Unauthorized gcid/uid/password combination"
      this.setState({ errorBag: errorBag });
      return;
    }
    this.busyMsg("Fetching authorization token...");
    var tokenResult = await this.authService.getUserToken(valueBag.gcid, valueBag.uid, valueBag.pwd);
    if (tokenResult.hasError) {
      errorBag.auth = "There was a problem fetching your authorization token. ";
      errorBag.auth = errorBag.auth + tokenResult.messages.join(". ");
      this.setState({ errorBag: errorBag });
      return;
    }
    var sessionToken = tokenResult.dataResult;

    this.busyMsg("Fetching user information...");
    var userInfoResult = await this.coreService.fetchUser(valueBag.gcid, valueBag.uid, sessionToken);
    if (userInfoResult.hasError) {
      errorBag.auth = "There was a problem fetching your user information. ";
      errorBag.auth = errorBag.auth + userInfoResult.messages.join(". ");
      this.setState({ errorBag: errorBag });
      return;
    }
    var userInfo = userInfoResult.dataResult;
    valueBag.userInfo = userInfo;

    this.busyMsg("Confirming glasschain core services are available...");
    let isCorePingable = await this.coreService.pingCore();
    //let isCoreDbPingable = await this.coreService.pingCoreDb();
    if (isCorePingable.hasError) // || isCoreDbPingable.hasError)
    {
      errorBag.auth = "There was a problem pinging glasschain core services. ";
      errorBag.auth = errorBag.auth + isCorePingable.messages.join(". ");
      //errorBag.auth = errorBag.auth + isCoreDbPingable.messages.join(". ");
      this.setState({ errorBag: errorBag });
      return;
    }
    this.busyMsg("glasschain core services confirmed.");
    await this.sleep(1000);


    this.busyMsg("Checking for updated master data...");
    var masterDataSyncResult = await this.syncMasterDataCatalogs(valueBag.gcid, valueBag, errorBag, sessionToken);
    if (!masterDataSyncResult) return;
    this.busyMsg("Local Master Catalogs are up-to-date.");
    await this.sleep(1000);

    // get allowedLocations
    var warehousesCatResult = await this.localMasterDataService.fetchMasterCatalog(valueBag.gcid, "warehousescatalog");
    if (warehousesCatResult.hasError)
    {
      errorBag.auth = "There was a problem fetching the receiving warehouses catalog from local storage. "
      errorBag.auth = errorBag.auth + warehousesCatResult.messages.join(". ");
      this.setState({ errorBag: errorBag });
      return;
    }
    this.busyMsg("Getting user warehouses...")
    var allLocations = warehousesCatResult.dataResult.warehouses.map((w) =>
    {
      return {id: w.warehouse.id, name: w.warehouse.name};
    });

    // filter locations by the user's allowed locations
    var userAllowedLocationIds = (Array.isArray(userInfo.allowedLocations)) ? userInfo.allowedLocations : [];
    var allowedLocations = (userAllowedLocationIds.length > 0)
      ? allLocations.filter(loc => userAllowedLocationIds.some(id => String(id) === String(loc.id)))
      : [];

    if (allowedLocations.length === 0)
    {
      errorBag.auth = "You do not have any allowed locations assigned to your account, or your assigned locations are inactive. Please contact your administrator.";
      this.setState({ errorBag: errorBag });
      return;
    }

    // get version info
    this.busyMsg("Getting MSA API version information...");
    var msaCoreVersionResponse = await this.coreService.fetchVersion();
    if (msaCoreVersionResponse.hasError){
      errorBag.auth = "There was a problem fetching MSA API versioning information ";
      errorBag.auth = errorBag.auth + msaCoreVersionResponse.messages.join(". ");
      this.setState({ errorBag: errorBag });
      return;
    }

    this.busyMsg("Getting QA API version information...");
    var qaCoreVersionResponse = await this.coreService.fetchQaVersion();
    if (qaCoreVersionResponse.hasError){
      errorBag.auth = "There was a problem fetching QA API versioning information ";
      errorBag.auth = errorBag.auth + qaCoreVersionResponse.messages.join(". ");
      this.setState({ errorBag: errorBag });
      return;
    }

    this.busyMsg("Logging in...")
    // we're good! Pass the results back up to the Auth Page
    this.setState({ errorMessage: null });
    // deal with getting the default location info
    this.busyMsg("Fetching any last user information.  Getting last warehouse used....");
    console.log("locating last warehouse used. Defaults to first warehouse in list if not found.");
    
    var lastUserInfo = (this.localStorageService.hasLastUserInfo())
      ? this.localStorageService.getLastUserInfo()
      : null;
    var lastWarehouseId = (lastUserInfo && lastUserInfo.locationinfo && lastUserInfo.locationinfo.warehouse)
      ?  String(lastUserInfo.locationinfo.warehouse.id)
      : "0";

    var warehouse = (lastWarehouseId !== "0") ?
      allowedLocations.find(aw => String(aw.id) === lastWarehouseId) :
      null;
    if (!warehouse) warehouse = allowedLocations[0];

    // let's go ahead and fetch the proper locationInfo
    this.busyMsg("Fetching last user information. Getting warehouse details...");
    console.log("fetching current warehouse from master catalog. ");

  
    var currentWarehouse = await DataService.fetchLocationByCatAndName(warehousesCatResult.dataResult, warehouse.name); // static! Used when we already have the warehouse catalog
    console.log("currentWarehouse: ");
    console.info(currentWarehouse);
    this.busyMsg("Setting Sublocations...");
    currentWarehouse.sublocation = (this.state.lastUserSession && this.state.lastUserSession.locationInfo && this.state.lastUserSession.locationInfo.sublocation) ?
      this.state.lastUserSession.locationInfo.sublocation : 
      currentWarehouse.auxInfo.sublocations[0];
    console.log("sublocation: ")
    console.info(currentWarehouse.sublocation);

    
    var result = {
        "gcid": valueBag.gcid, "uid": valueBag.uid, "isValid": true, token: sessionToken,
        offlineTokenCanExpire: true, allowedLocations: allowedLocations,  
        currentLocationId: warehouse.id,
        currentWarehouse: currentWarehouse,
        buildVer: this.state.buildVersion, msaAppVer: this.ConfigService.getAppVersion(), 
        msaCoreVer: msaCoreVersionResponse.dataResult, qaCoreVer: qaCoreVersionResponse.dataResult
      };
    console.group("In Auth - result passed back to HomeLayout onSuccessfulLogin: ");
    console.info(result);
    console.groupEnd();
    this.busyMsg("Saving Login information...");
    await this.props.onSuccessfulLogin(result);
  }
  catch(err){
    this.busyOff();
    var newErrorBag = {};
    newErrorBag.unexpectedError = "The system got an unexpected error while trying to log you in! [" + err.name + ": " + err.message + "]";
    this.setState({errorBag: newErrorBag});
  }
  finally{
    this.busyOff();
  }
 }

 getValidationErrors(valueBag) {
  var result = {};
  var gcidErr = ((!valueBag.gcid) || (valueBag.length < 2)) ? "Invalid gcid" : null;
  var uidErr = ((!valueBag.uid) || (valueBag.uid.length < 6)) ? "Invalid uid" : null;
  var pwdErr = ((!valueBag.pwd) || (valueBag.pwd.length < 6)) ? "Invalid password" : null;
  if (gcidErr) result.gcid = gcidErr;
  if (uidErr) result.uid = uidErr;
  if (pwdErr) result.pwd = pwdErr;
  return result;
}

deleteErrorBagKey(key)
{
  var newErrorBag = this.state.errorBag;
  delete newErrorBag[key];
  this.setState({errorBag: newErrorBag});
}


  render() 
  {

    var errors;
    if (Object.keys(this.state.errorBag).length > 0) 
    {
      var entries = Object.entries(this.state.errorBag);
      var errorBody = entries.map(e => {
        return <div>{e[1]}</div>
      });
      errors = <div id="errorbox">
        {errorBody}
      </div>
    } else {
      errors = <span/>
    }

    var busySpan = (this.state.isBusy) ? <div id="busybox"><FontAwesomeIcon icon={faSyncAlt} color="white" spin/><span style={{ color: "lightgrey", fontSize: "8pt" }}>{this.state.busyMsg}</span></div>
      : <span/>;

    return (
      <div id="authcontainer">
        <img src={gcObservationsLogo} alt="glasschain observations" id="gcobslogo" onClick={(e) => this.toggleForceMastersUpdate()}/>

        <LoginPanel
          deviceInfo={this.props.deviceInfo}
          isSupportedDevice={this.isSupportedDevice}
          buildVersion={this.state.buildVersion}
          appVersion={this.state.appVersion}
          isNewBuild={this.state.isNewBuild}
          msaCoreVersion={this.state.msaCoreVersion}
          msaQaVersion={this.state.msaQaVersion} 
          onLoginAttempt={this.onLoginAttempt}
          onDeleteErrorBagKeyRequest={this.deleteErrorBagKey}
          lastUserInfo={this.state.lastUserInfo}
          errorBag={this.state.errorBag}
          forceMastersUpdateFlag={this.state.forceMastersUpdate}
        />

        {errors}

        {busySpan}


      </div>
    )
  }

}